"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc");

var _spacingSchema = require("../../../modifiers/spacingSchema");

var _breakpointSizeSchema = require("../../../modifiers/breakpointSizeSchema");

var _modifiers = require("./modifiers");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var schema = (0, _reactDesc.describe)({
  displayName: 'Column'
});
schema.propTypes = _objectSpread({
  offset: _reactDesc.PropTypes.oneOf(Object.keys(_modifiers.offsetModifiersConfig)).description('Defines the number of columns to the left that are "skipped" before this column is rendered.')
}, (0, _spacingSchema.makeSpacingSchemaPropTypes)(), {}, (0, _breakpointSizeSchema.makeBreakpointSizePropTypes)(), {
  span: _reactDesc.PropTypes.oneOf(Object.keys(_modifiers.spanModifiersConfig)).description('Defines the width of the column being rendered.'),
  display: _reactDesc.PropTypes.string.description('A pass-through CSS value for the display attribute.'),
  height: _reactDesc.PropTypes.string.description('A pass-through CSS value for the height attribute.'),
  maxHeight: _reactDesc.PropTypes.string.description('A pass-through CSS value for the max-height attribute.'),
  maxWidth: _reactDesc.PropTypes.string.description('A pass-through CSS value for the max-width attribute.'),
  minHeight: _reactDesc.PropTypes.string.description('A pass-through CSS value for the min-height attribute.'),
  minWidth: _reactDesc.PropTypes.string.description('A pass-through CSS value for the min-width attribute.'),
  visibility: _reactDesc.PropTypes.string.description('A pass-through CSS value for the visibility attribute.'),
  width: _reactDesc.PropTypes.string.description('A pass-through CSS value for the width attribute.')
});
var _default = schema;
exports.default = _default;